export const formatDate = (seconds) => {
    let date = new Date(seconds * 1000);

    const options = { year: 'numeric', month: 'long', day: '2-digit' };
    const dateString = date.toLocaleDateString('en-US', options);

    return dateString;
};

export const hasAllPrivileges = (userPrivileges, requiredPrivileges) => {
    if(requiredPrivileges == null || requiredPrivileges.length == 0) return true;
    if (!userPrivileges) return false;

    return requiredPrivileges.every(privilege => userPrivileges.includes(privilege));
}